module.exports = { id: "chevron-right", url: "/build/app/img/symbols.svg#chevron-right", viewBox: "", toString: function() { return this.url; } };